import { z } from "zod/v4";

import { LiteralSchema } from "../../../utils";
import { SHOPIFY_API_VERSION } from "../api-version";

export const SHOPIFY_GRAPHQL_API_VERSION_HEADER = "x-shopify-api-version";

/**
 * The versions a caller may pin on a request: the app's canonical default
 * ({@link SHOPIFY_API_VERSION}), stable versions with an explicit per-request
 * compatibility need, and `unstable` for its separately generated operations.
 */
export const SHOPIFY_GRAPHQL_API_VERSIONS = [
  SHOPIFY_API_VERSION,
  "2026-07",
  "unstable",
] as const;

export type ShopifyGraphqlApiVersion =
  (typeof SHOPIFY_GRAPHQL_API_VERSIONS)[number];

export const ShopifyGraphqlRequestBodySchema = z.object({
  operationName: z.string().optional(),
  query: z.string(),
  version: z.string().optional(),
  variables: z.record(z.string(), LiteralSchema),
});

export type ShopifyGraphqlRequestBodyType = z.infer<
  typeof ShopifyGraphqlRequestBodySchema
>;
